import React from "react";
import "./instagram.css";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";
const Instagram = () => {
  return (
    <div>
      <h3 className="text-center mt-5">INSPIRATION</h3>
      <div className="container-fluid">
        <Row lg={5}>
          <Fade left>

          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/b7m2LZK/instagram4.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
          </Fade>
          <Fade right>
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/NYD00MB/instagram1.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
            <Fade bottom>
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/9pM071k/instagram2.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>

            <Fade top>
            
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/TgXD47Y/instagram3.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
            <Fade left>
            
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/JRWW0q9/instagram5.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
        </Row>

        <Row lg={5} className="mt-2 mb-3">
        <Fade right>
            
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/xL4hv0L/instagram6.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
            <Fade bottom>
            
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/S3wtcXg/instagram7.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
            <Fade top>
            
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/RyCB2V5/instagram8.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
            <Fade left>
            
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/LxfKM9s/instagram9.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
            <Fade bottom>
            
          <Col sm={12}>
            <div className="hovereffect">
              <img
                style={{ height: "250px" }}
                className="img-responsive"
                src="https://i.ibb.co/M86rHPn/instagram10.jpg"
                alt=""
              />
              <div className="overlay">
                <p>
                  <Link to="/">
                    <i className="fab fa-instagram fa-2x"></i>
                  </Link>
                </p>
              </div>
            </div>
          </Col>
            </Fade>
        </Row>
      </div>
    </div>
  );
};

export default Instagram;